module.exports = __webpack_public_path__ + "static/img/qrcode.39796c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.png
// module id = jWhC
// module chunks = 1